import React from "react";

const RVFiltersPreview = ({ config, classes }) => {
  const isVertical = config.layout === "vertical";

  return (
    <div className={classes} style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          display: "flex",
          gap: "8px",
          flexDirection: isVertical ? "column" : "row",
          flexWrap: isVertical ? "nowrap" : "wrap"
        }}
      >
        {config.filters.length === 0
          ? "No Filter Found"
          : config.filters.map((filter) => (
              <div
                key={filter.display}
                className="d_flex px_3 justify_center align_center text_wrap_nowrap z-rv-filter"
                style={{
                  width: isVertical ? "100%" : "auto"
                }}
              >
                {filter.filter_custom_label || filter.display}
              </div>
            ))}
      </div>
    </div>
  );
};

export default RVFiltersPreview;
